import React from 'react';
import { useTranslation } from '../utils/i18n';
import './SuccessModal.css';

interface ErrorModalProps {
  isOpen: boolean;
  onClose: () => void;
  message?: string;
}

const ErrorModal: React.FC<ErrorModalProps> = ({ isOpen, onClose, message }) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const displayMessage = message || t('apiDocPanel.errorModal.dataNotFound');

  return (
    <div className="modal-backdrop" onClick={handleBackdropClick}>
      <div className="modal-container">
        <div className="modal-content">
          <div className="modal-icon">
            <div className="warning-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="78" height="78" viewBox="0 0 78 78" fill="none">
                <circle cx="39" cy="39" r="39" fill="#FFC107"/>
                <path d="M39 25V45" stroke="white" strokeWidth="4" strokeLinecap="round"/>
                <circle cx="39" cy="55" r="3" fill="white"/>
              </svg>
            </div>
          </div>
          <div className="modal-text">
            {displayMessage}
          </div>
          <div className="modal-actions">
            <button 
              className="btn btn-primary"
              onClick={onClose}
            >
              {t('apiDocPanel.errorModal.okButton')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ErrorModal;
